<template>
  <div>
    <h1>Novo Cliente</h1>
    <b-card>
      <Form @saved="loadData" :new="true" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("clientes", ["cliente"]),
  },
  methods: {
    ...mapActions("clientes", ["ActionNewCliente"]),
    loadData(id) {
      this.$router.push({ name: "clientes_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewCliente();
  },
};
</script>

<style></style>
